import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, inject, viewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ColumnMode, DatatableComponent, NgxDatatableModule, SelectionType } from '@swimlane/ngx-datatable';
import { lastValueFrom } from 'rxjs';
import { BarManagementService, Bar, IBarQuery, BarQuery, BarState } from 'src/app/api/api-bar-management.service.generated';
import { LocationFilterByOutletProperty, OutletProperty } from 'src/app/api/api-campaigns.service.generated';
import { ConfirmDialogModel } from 'wecheer-common';

@Component({
  selector: 'app-filter-by-outlet-property',
  templateUrl: './filter-by-outlet-property.component.html',
  styleUrls: ['./filter-by-outlet-property.component.scss'],
  imports: [
    NgxDatatableModule,
    MatIconModule
  ]
})
export class FilterByOutletPropertyComponent implements OnInit, OnChanges {
  private dialog = inject(MatDialog);
  private bmApi = inject(BarManagementService);


  @Input() model: LocationFilterByOutletProperty;
  @Output() delete = new EventEmitter<LocationFilterByOutletProperty>();

  readonly datatable = viewChild<DatatableComponent>('datatable');
  readonly el = viewChild<ElementRef>('el'); // who is el?

  readonly headerHeight = 50;
  readonly rowHeight = 45;
  readonly pageLimit = 10;

  rows: Bar[] = [];
  filter: IBarQuery;
  isLoading: boolean;
  isLoadingDisabled = false; // disabled ngx-datatable internal loader
  isError = false;
  error = '';
  isAllSelected = false;
  included: string[] = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  total?: number;
  barState = BarState;

  ngOnInit() {
  }

  ngOnChanges(): void {
    if (!this.model) return;
    this.search();
  }

  async search() {
    const administrativeAreaL1s = this.model.outletPropertyItems
      .filter(x => x.outletProperty === OutletProperty.AdministrativeAreaL1).map(t => t.value);
    const administrativeAreaL2s = this.model.outletPropertyItems
      .filter(x => x.outletProperty === OutletProperty.AdministrativeAreaL2).map(t => t.value);
    this.filter = new BarQuery({
      administrativeAreaL1s: administrativeAreaL1s,
      administrativeAreaL2s: administrativeAreaL2s,
      skip: 0,
      maxItems: 10 * 1000
    });
    this.rows = [];
    this.included = [];
    this.isAllSelected = false;

    // set the loading flag, which serves two purposes:
    // 1) it prevents the same page from being loaded twice
    // 2) it enables display of the loading indicator
    this.isLoading = true;
    this.isError = false;
    this.error = '';

    this.filter.nextToken = null; // we don't paginate this. sad panda noises

    try {
      const chunk = await lastValueFrom(this.bmApi.queryBars(new BarQuery(this.filter)));
      if (!chunk || !chunk.items)
        return;

      this.total = chunk.total;

      this.rows = chunk.items;
    } catch (error) {
      const err = error;
      this.isError = true;
      this.error = JSON.stringify(err);
    } finally {
      this.isLoading = false;
    }
  }

  async onDelete() {
    const confirmResult = await new ConfirmDialogModel('Are you sure you want to delete this filter?').show(this.dialog);
    if (!confirmResult) return;
    this.delete.emit(this.model);
  }
}
